export const SIZE_EXTRA_SMALL = 'xs';
export const SIZE_SMALL = 'sm';
export const SIZE_MEDIUM = 'md';
export const SIZE_LARGE = 'lg';

export const DEFAULT_BACKGROUND_COLOR_OPACITY = 0.1;

export const DEFAULT_BORDER_COLOR = 'rgb(204,204,204)';
export const DEFAULT_ERROR_BORDER_COLOR = 'rgb(220,53,69)';
export const DEFAULT_ERROR_BACKGROUND_COLOR = `rgba(220,53,69,${DEFAULT_BACKGROUND_COLOR_OPACITY})`;
export const DEFAULT_FOCUS_BORDER_COLOR = 'rgb(13,110,253)';
export const DEFAULT_FOCUS_BACKGROUND_COLOR = `rgba(13,110,253,${DEFAULT_BACKGROUND_COLOR_OPACITY})`;
export const DEFAULT_VALID_BORDER_COLOR = 'rgb(25,135,84)';
export const DEFAULT_VALID_BACKGROUND_COLOR = `rgba(25,135,84,${DEFAULT_BACKGROUND_COLOR_OPACITY})`;
